// extracted by mini-css-extract-plugin
export default {"mCard":"NB-z","image":"OB-z","imageNoBackground":"PB-z","imageHasCategory":"QB-z","fullWidth":"RB-z"};